import RefBooksModule from './refbooks.module';
import Collection from '../../collection';
import Config from '../../config';

import { handle } from '../../service/messages';
import { error } from '../../ui/messages'
import { hashify } from '../../utils/arrays';
import { roleC } from '../../roles';
import { beginLock, endLock } from '../../loader';

import i18n from '../../i18n';
let ifn; i18n.then( f => ifn = f );



export default RefBooksModule.extend( {

    template: 'module/refbooks/scripts.form',

    url() {
        return this.model.id
            ? `scripts/${this.model.id}`
            : `scripts/new/${this.model.get( 'type' ).toLowerCase()}/${this.model.get( 'operation' ).toLowerCase()}`;
    },

    open(script) {
        const binding = this.bind( script );
        binding.then( () => {
            if (!script.id)
            if (this.state().cluster && this.state().cluster.id != -1)
                script.set( 'cluster', this.state().cluster );
            else if (~roleC.indexOf( Config.role() ))
                script.set( 'cluster', Config.cluster() );
        } );

        return binding;
    },

    start() {
        this.listenTo( this.model, 'change:title change:webhook_server change:description change:on change:script change:cluster',
            () => this.Buttons.render() );

        this.listenTo( this.model, 'change:workgroups change:type change:operation change:entity_type change:types change:priorities change:roles change:statuses_before change:statuses_after change:stages_before change:stages_after change:user_organizations_before change:user_organizations_after change:user_roles_before change:user_roles_after change:user_types_before change:user_types_after change:user_tags_before change:user_tags_after',
            () => this.render() );
    },

    stop() {
        // todo ?
        this.stopListening( this.model );
    },

    serialize() {
        const types = hashify( this.options.types,
            type => [type.id, type] );

        const priorities = hashify( this.options.priorities,
            priority => [priority.id, priority] );

        const statuses = hashify( this.options.statuses,
            status => [status.id, status] );

        const clusters = hashify( this.options.clusters, 
            cluster => [cluster.id, cluster] );
        const organizations = hashify( this.options.organizations.toJSON(),
            org => [org.id, { ...org, cluster: clusters[org.cluster_id] }] );
        const workgroups = hashify( this.options.workgroups.toJSON()
            .filter( model => model.defaults )
            .map( ({ id, organization: { name, id: orgId } }) => 
                ({ id, name, cluster: organizations[orgId].cluster }) ),
            workgroup => [workgroup.id, workgroup] );

        return { 
            enhancedPriorities: new Collection( [
                { id: null, name: ifn( 'issue::label - no priority' ), },
                ...this.options.priorities.toJSON(),
            ] ),

            workgroupsFn: () => Object.values( workgroups )
                .filter( workgroup => 
                    !this.model.get( 'cluster' ) ||
                    this.model.get( 'cluster' ).id == workgroup.cluster.id )
                .sort( (wgA, wgB) => {
                    const nameA = wgA.name.toLowerCase();
                    const nameB = wgB.name.toLowerCase();

                    if (nameA < nameB)
                        return -1;
                    else if (nameA > nameB)
                        return 1;
                    else
                        return 0;
                } ),
            
            organizationsFn: () => Object.values( organizations )
                .filter( org => 
                    !this.model.get( 'cluster' ) ||
                    this.model.get( 'cluster' ).id == org.cluster.id )
                .sort( (orgA, orgB) => {
                    const nameA = orgA.name.toLowerCase();
                    const nameB = orgB.name.toLowerCase();

                    if (nameA < nameB)
                        return -1;
                    else if (nameA > nameB)
                        return 1;
                    else
                        return 0;
                } ),
            
            stages: [
                { id: 0, name: 'glossary::stage - rejected (0)' }, 
                { id: 1, name: 'glossary::stage - in progress (1)' }, 
                { id: 2, name: 'glossary::stage - completed (2)' }, 
            ],

            serversFn: () => this.options.servers.toJSON()
                .filter( server => 
                    !server.cluster ||
                    !this.model.get( 'cluster' ) ||
                    this.model.get( 'cluster' ).id == server.cluster.id )
                .map( ({ id, name, server }) => ({ id, title: name, server }) ),

            statusesFn: () => {
                const cluster = this.model.get( 'cluster' );
                const isolated = cluster && clusters[cluster.id].isolated;

                return this.options.statuses.toJSON()
                    .filter( status =>
                        !cluster ||
                        !isolated && !status.cluster ||
                         isolated && status.cluster && status.cluster.id == cluster.id )
                    .map( ({ id, name, cluster }) => ({ id, title: name, cluster }) )
            },

            clustersFn: () => {
                const clusters = [
                    ...this.model.get( 'types' )
                        .filter( type => types[type.id] )
                        .map( type => types[type.id].cluster ),
                    ...this.model.get( 'priorities' )
                        .filter( priorityId => priorities[priorityId] )
                        .map( priorityId => priorities[priorityId].cluster ),
                    ...this.model.get( 'workgroups' )
                        .filter( workgroup => workgroups[workgroup.id] )
                        .map( workgroup => workgroups[workgroup.id].cluster ),
                    ...[...this.model.get( 'user_organizations_before' ), ...this.model.get( 'user_organizations_after' )]
                        .filter( organization => organizations[organization.id] )
                        .map( organization => organizations[organization.id].cluster ),
                    ...[...this.model.get( 'statuses_before' ), ...this.model.get( 'statuses_after' )]
                        .filter( status => statuses[status.id] )
                        .map( status => statuses[status.id].cluster )
                ];

                if (this.model.get( 'webhook_server' ))
                    clusters.push( this.model.get( 'webhook_server' ).cluster );

                const hash = hashify( clusters.filter( cluster => !!cluster ),
                    cluster => [cluster.id, cluster] );

                const distinctClusters = Object.values( hash );

                if (distinctClusters.length == 0)
                    return this.options.clusters.toJSON();
                else if (distinctClusters.length == 1)
                    return distinctClusters;
                else
                    return [];
            },
        };
    },

    events: {

        'click .-close'() {
            this.trigger( RefBooksModule.BACK );
        },

        'click .-save'() {
            beginLock( this );

            return this.options.scripts.save( this.Fields ).then( 

                (/*field*/) => this.trigger( RefBooksModule.BACK ), 

                message => {
                    endLock( this );
                    handle( this.Fields, error( message ) );
                } );
        },

    },

    [RefBooksModule.event( 'Fields:type:toggle' )](type) {
        return this.model.set( 'type', type ), this.navigated();
    },

    [RefBooksModule.event( 'Fields:entity:toggle' )](entityType) {
        return this.model.set( 'entity_type', entityType ), this.navigated();
    },

    [RefBooksModule.event( 'Fields:op:toggle' )](operation) {
        return this.model.set( 'operation', operation ), this.navigated();
    },

    [RefBooksModule.event( 'Ace:edit' )](newScript) {
        this.model.set( 'script', newScript );
    }

}, {

    NEW: 'new-script',

    EDIT: 'edit-script',

} );



// WEBPACK FOOTER //
// ./src/js/module/refbooks/scripts.form.js